import AppLogs from 'pages/appLogs'

export default [
  { path: '/app-logs', name: 'appLogs', component: AppLogs, meta: {permits: ['app_logs']} },
]
